// extracted by mini-css-extract-plugin
module.exports = {"root":"CarouselSlider_root__P64Xt","slider":"CarouselSlider_slider__4O_9S"};